/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OPCharge from './op-charge';
import OPChargeDetail from './op-charge-detail';
import OPChargeUpdate from './op-charge-update';
import OPChargeDeleteDialog from './op-charge-delete-dialog';

const OPChargeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OPCharge />} />
    <Route path="new" element={<OPChargeUpdate />} />
    <Route path=":id">
      <Route index element={<OPChargeDetail />} />
      <Route path="edit" element={<OPChargeUpdate />} />
      <Route path="delete" element={<OPChargeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OPChargeRoutes;
